module.exports = __webpack_public_path__ + "static/media/warningTips.a79ca81d.svg";